import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";

import { red, green } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "80ch",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
  sell: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
  },
  buy: {
    color: theme.palette.getContrastText(green[500]),
    backgroundColor: green[500],
  },
}));

const DetailsDialog = ({ openDetails, handleCloseDetails, data }) => {
  const classes = useStyles();
  const closeDialog = () => {
    handleCloseDetails();
  };

  useEffect(() => {

  }, [data]);

  return (
    <div>
      <Dialog
        open={openDetails}
        onClose={closeDialog}
        aria-labelledby="form-dialog-title"
        disableEnforceFocus={true}
      >
        <DialogTitle id="form-dialog-title">Item Movement</DialogTitle>
        <DialogContent>
          {data.length > 0 ? (
            <List className={classes.root}>
              {data.map((item, index) => {

                var ts_hms = new Date(item.ItemActionDate)
                  .toISOString()
                  .replace(/T/, " ") // replace T with a space
                  .replace(/\..+/, "");

                return (
                  <React.Fragment key={index}>
                    <ListItem alignItems="flex-start" style={{ minWidth: 500 }}>
                      <ListItemAvatar>
                        <Avatar
                          className={
                            item.ItemQty > 0 ? classes.buy : classes.sell
                          }
                        >
                          {item.ItemQty}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.ItemName}
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="body2"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {item.ItemAction} on <b>{ts_hms}</b>
                            </Typography>
                            <div>
                              <br />
                              {`Price: `}
                              <b>{`$ ${item.ItemPrice}`}</b>
                              <br />
                              {`Location: `}
                              <b>{`${item.ItemLocation}`}</b>
                              <br />
                              {` Who: `}
                              <b>{`${item.ItemActionWho}`}</b>
                              {item.ItemClient && (
                                <span>
                                  <br />
                                  Client:
                                  <b>{`${item.ItemClient}`}</b>
                                </span>
                              )}
                              {item.ItemNotes && (
                                <span>
                                  <br />
                                  Notes:
                                  <b>{`${item.ItemNotes}`}</b>
                                </span>
                              )}
                            </div>
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </React.Fragment>
                );
              })}
            </List>
          ) : (
            `Loading...`
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DetailsDialog;
